"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    studentStandardsPerformance: {
        title: 'Performance by Standards',
        student: 'Student',
        classAverage: 'Class Average',
        chartAriaLabel: 'vertical grouped bar of performance by standards, comparing {{count}} standards.',
        viewAsDataTable: 'View as data table',
        dataTable: {
            standard: 'Standard',
            studentAverange: 'Student Average',
            classAverage: 'Class Average',
        },
    },
};
